<template>
    <div>
        <div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64">
                </v-progress-circular>
            </v-overlay>
        </div>
        <v-container fluid class="product-management mt-15 px-1">
            <v-row>
                <v-col cols="12" md="6" class="py-2">
                    <v-btn @click.stop="Abrir()" color="primary" class="ma-2">
                        <v-icon color="white">mdi-filter</v-icon>
                    </v-btn>
                    <v-btn v-if="retorno" @click="regresar()" class="ma-2" color="error">
                        Regresar
                    </v-btn>
                </v-col>
                <v-col cols="12">
                    <v-card>
                        <v-card-title class="pa-5 pb-3 primary">
                            <v-icon class="pr-3">mdi-chart-bar</v-icon>
                            <p style="color: white;">{{ this.titulo }}</p>
                            <v-spacer></v-spacer>
                            <div v-if="verificarpermisoexcel">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <JsonExcel :fetch="fetchData" :name="`${nombreArchivo}.xls`"
                                                :before-generate="startDownload" :before-finish="finishDownload"
                                                worksheet="nombreArchivo">
                                                <v-icon dark style="cursor: pointer !important;" class="hover">
                                                    mdi-file-excel-outline
                                                </v-icon>
                                            </JsonExcel>
                                        </span>
                                    </template>
                                    <span>Descargar Excel</span>
                                </v-tooltip>

                            </div>
                        </v-card-title>
                        <v-card-text>
                            <v-alert type="success">
                                {{ this.subtitulo }}
                            </v-alert>
                            <v-row>
                                <v-col cols=12 md="5" v-if="nuevaPeticion" style="float: none; margin: 0 auto; ">
                                    <vs-list>
                                        <vs-list-header title="Reportes" color="success"></vs-list-header>
                                        <vs-list-item title="Total" subtitle="">
                                            <v-btn rounded color="success" @click="notify(1, dato[0].Reportes)" dark>{{
                                                dato[0].Reportes }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Concluidos" subtitle="">
                                            <v-btn rounded color="success" @click="notify(2, dato[0].Concluidos)" dark>{{
                                                dato[0].Concluidos }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Concluidos Totales" subtitle="">
                                            <v-btn rounded color="success" @click="notify(19, dato[0].ConcxFC)" dark>{{
                                                dato[0].ConcxFC }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Promedio en días" subtitle="">
                                            <v-btn rounded color="success" @click="notify(3, dato[0].PromDias)" dark>{{
                                                dato[0].PromDias >= 0 ? dato[0].PromDias : 0 }} días</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Promedio de efectividad" subtitle="">
                                            <v-btn rounded color="success" @click="notify(4, dato[0].Efectividad)" dark>{{
                                                dato[0].Efectividad }} %</v-btn>
                                        </vs-list-item>
                                        <vs-list-header title="Pendientes" color="warning"></vs-list-header>
                                        <vs-list-item title="Total" subtitle="">
                                            <v-btn rounded color="warning" @click="notify(5, dato[0].Pendientes)" dark>{{
                                                dato[0].Pendientes }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="1ra. Atención" subtitle="">
                                            <v-btn rounded color="warning" @click="notify(6, dato[0].PrimeraAtn)" dark>{{
                                                dato[0].PrimeraAtn }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="En averiguación previa" subtitle="">
                                            <v-btn rounded color="warning" @click="notify(7, dato[0].AvePrevia)" dark>{{
                                                dato[0].AvePrevia }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="En consignación" subtitle="">
                                            <v-btn rounded color="warning" @click="notify(8, dato[0].Consignacion)" dark>{{
                                                dato[0].Consignacion }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Conductor detenido" subtitle="">
                                            <v-btn rounded color="warning" @click="notify(9, dato[0].CondDetenido)" dark>{{
                                                dato[0].CondDetenido }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Vehiculo detenido" subtitle="">
                                            <v-btn rounded color="warning" @click="notify(11, dato[0].VehDetenido)" dark>{{
                                                dato[0].VehDetenido }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Sin peritaje" subtitle="">
                                            <v-btn rounded color="warning" @click="notify(13, dato[0].SinPeritaje)" dark>{{
                                                dato[0].SinPeritaje }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-header title="Con peritaje" color="primary"></vs-list-header>
                                        <vs-list-item title="Total" subtitle="">
                                            <v-btn rounded color="primary" @click="notify(14, dato[0].ConPeritaje)" dark>{{
                                                dato[0].ConPeritaje }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Favorable" subtitle="">
                                            <v-btn rounded color="primary" @click="notify(15, dato[0].Favorable)" dark>{{
                                                dato[0].Favorable }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Contrario" subtitle="">
                                            <v-btn rounded color="primary" @click="notify(16, dato[0].Contrario)" dark>{{
                                                dato[0].Contrario }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Corresponsabilidad" subtitle="">
                                            <v-btn rounded color="primary" @click="notify(17, dato[0].Corresponsabilidad)"
                                                dark>{{ dato[0].Corresponsabilidad }}</v-btn>
                                        </vs-list-item>
                                        <vs-list-item title="Informe" subtitle="">
                                            <v-btn rounded color="primary" @click="notify(18, dato[0].Informe)" dark>{{
                                                dato[0].Informe }}</v-btn>
                                        </vs-list-item>
                                    </vs-list>
                                </v-col>
                                <v-col cols="12" v-if="nuevoReporte">
                                    <div class="table-responsive">
                                        <table id="tabla" class="table table-hover display responsive no-wrap"
                                            :style="{ float: 'none', margin: '0 auto', width: tamaño + '%' }"
                                            v-if="listado.length > 0">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th v-for="encabezado in headers">{{ encabezado.text }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="reporte in listado" :key="reporte.id">
                                                    <td></td>
                                                    <template v-if="tipo != 4">
                                                        <td><a class="link"
                                                                @click="irDetalle(reporte.Reporte, reporte.Indice, reporte)">{{
                                                                    reporte.Reporte }}-{{ reporte.Indice }}</a></td>
                                                        <td>{{ reporte.Fechareporte }}</td>
                                                    </template>
                                                    <template v-if="tipo == 19 || tipo == 2 || tipo == 3">
                                                        <td>{{ reporte.Fechaconclusion }}</td>
                                                    </template>
                                                    <td>{{ reporte.Asistencia }}</td>
                                                    <template v-if="tipo == 3 && tipo != 4">
                                                        <td>{{ reporte.Diferencia }}</td>
                                                    </template>
                                                    <td>{{ reporte.Ciudad }}</td>
                                                    <td>{{ reporte.Aseguradora }}</td>
                                                    <td>{{ reporte.Abogado }}</td>
                                                    <td>{{ reporte.NumSiniestro }}</td>
                                                    <template v-if="tipo == 4">
                                                        <td>{{ reporte.Formadeconclusión }}</td>
                                                        <td>{{ reporte.Total }}</td>
                                                    </template>
                                                    <template v-if="tipo == 1">
                                                        <td>{{ reporte.FechaSiniestro }}</td>
                                                        <td>{{ reporte.Ajustador }}</td>
                                                        <td>{{ reporte.Asegurado }}</td>
                                                        <td>{{ reporte.Conductor }}</td>
                                                        <td>{{ reporte.Poliza }}</td>
                                                        <td>{{ reporte.Robo }}</td>
                                                        <td>{{ reporte.Delito }}</td>
                                                        <td>{{ reporte.Fechaconclusion }}</td>
                                                        <td>{{ reporte.Flotilla }}</td>
                                                        <td>{{ reporte.Fecha_turnado }}</td>
                                                        <td>{{ reporte.Fecha_contacto }}</td>
                                                        <td>{{ reporte.Estado }}</td>
                                                        <td>{{ reporte.Avprevia }}</td>
                                                        <td>{{ reporte.Modelo }}</td>
                                                    </template>
                                                    <template v-if="tipo == 5">
                                                        <td>{{ reporte.Estado }}</td>
                                                        <td>{{ reporte.Fecha_Siniestro }}</td>
                                                        <td>{{ reporte.Conductor }}</td>
                                                        <td>{{ reporte.Asegurado }}</td>
                                                        <td>{{ reporte.Poliza }}</td>
                                                        <td>{{ reporte.Delito }}</td>
                                                        <td>{{ reporte.Flotilla }}</td>
                                                        <td>{{ reporte.Modelo }}</td>
                                                        <td>{{ reporte.AvPrevia }}</td>
                                                        <td>{{ reporte.Reserva }}</td>
                                                    </template>
                                                    <template
                                                        v-if="tipo == 6 || tipo == 7 || tipo == 8 || tipo == 9 || tipo == 10 || tipo == 15 || tipo == 16 || tipo == 17 || tipo == 18">
                                                        <td>{{ reporte.Reserva }}</td>
                                                    </template>
                                                    <template v-if="tipo == 11 || tipo == 12">
                                                        <td>{{ reporte.Estado }}</td>
                                                        <td>{{ reporte.FechaSiniestro }}</td>
                                                        <td>{{ reporte.Díasdetenido }}</td>
                                                        <td>{{ reporte.Conductor }}</td>
                                                        <td>{{ reporte.Asegurado }}</td>
                                                        <td>{{ reporte.Poliza }}</td>
                                                        <td>{{ reporte.Flotilla }}</td>
                                                        <td>{{ reporte.Reserva }}</td>
                                                    </template>
                                                    <template v-if="tipo == 13 || tipo == 14">
                                                        <td>{{ reporte.Estado }}</td>
                                                        <td>{{ reporte.FechaSiniestro }}</td>
                                                        <td>{{ reporte.Conductor }}</td>
                                                        <td>{{ reporte.Asegurado }}</td>
                                                        <td>{{ reporte.Poliza }}</td>
                                                        <td>{{ reporte.Delito }}</td>
                                                        <td>{{ reporte.Diassinperitaje }}</td>
                                                        <td>{{ reporte.Peritaje }}</td>
                                                        <td>{{ reporte.Reserva }}</td>
                                                    </template>
                                                    <template v-if="tipo == 19 || tipo == 2">
                                                        <td>{{ reporte.Formadetermino }}</td>
                                                        <td>{{ reporte.Estado }}</td>
                                                        <td>{{ reporte.FechaSiniestro }}</td>
                                                        <td>{{ reporte.Conductor }}</td>
                                                        <td>{{ reporte.Asegurado }}</td>
                                                        <td>{{ reporte.Poliza }}</td>
                                                        <td>{{ reporte.Peritaje }}</td>
                                                        <td>{{ reporte.AvPrevia }}</td>
                                                        <td>{{ reporte.Delito }}</td>
                                                        <td>{{ reporte.Modelo }}</td>
                                                    </template>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Buscar Estadisticas</span>
                        </v-card-title>
                        <v-card-text>
                            <v-form>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" class="ma-5">
                                            <span style="font-weight: bold;">Estado: </span>
                                            <multiselect style="border-color: brown !important;" v-model="busqueda.estado"
                                                deselect-label="No se puede remover el valor seleccionado"
                                                selected-label="Seleccionado" select-label="Seleccione el estado"
                                                track-by="esclave" label="esnombre" placeholder="Seleccione una opción"
                                                :options="estados" :allow-empty="false" dense ref="multiselect">
                                            </multiselect>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="busqueda.fechaini" label="Fecha inicio"
                                                        prepend-icon="mdi-calendar" readonly autofocus="autofocus"
                                                        v-bind="attrs" v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="busqueda.fechaini" :max="maxfecha"
                                                    @input="menu1 = false" locale="es-mx"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                                                transition="scale-transition" offset-y min-width="auto">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="busqueda.fechafin" label="Fecha fin"
                                                        prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="busqueda.fechafin" :max="maxfecha"
                                                    @input="menu2 = false" locale="es-mx"></v-date-picker>
                                            </v-menu>
                                        </v-col>

                                    </v-row>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="limpiarBusqueda()">
                                Cerrar
                            </v-btn>
                            <v-btn color="blue darken-1" text @click="busquedaEstadistica()">
                                Buscar
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import servicio from '@/services/estadistica/estadistica.service.js';
import JsonExcel from 'vue-json-excel';
import Inicio from '@/services/main/main.service.js';
import Documentos from '@/services/documentos/documentos.service.js';

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import 'datatables.net-responsive-dt'
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";

export default {
    components: {

        JsonExcel
    },
    data() {
        return {
            titulo: 'Estadistica',
            maxfecha: new Date().toISOString(),
            dialog: true,
            retorno: false,
            busqueda: {
                fechaini: '',
                fechafin: '',
                estado: ''
            },
            dato: [],
            estados: [],
            listado: [],
            headers: [],
            nuevaPeticion: false,
            nuevoReporte: false,
            titulo: '',
            menu1: false,
            menu2: false,
            selecionado: '',
            subtitulo: '',
            tamaño: 100,
            nombreArchivo: `EstadisticaSiniestros_${this.$moment().format("YYYY-MM-DD")}`,
            overlay: false,
            loadingTable: false,
            local: 'es-MX',
            verificarpermisoexcel: false,
            tipo: 0,
            registro: 20,
            busqueda2: {},
        }
    },
    computed: {
        ...mapState([
            "domain",
            "informationPage",
            "paginacion",
            "permission",
            "user"
        ]),
    },
    methods: {
        Abrir() {
            this.dialog = true;
            this.busqueda = {
                fechaini: '',
                fechafin: '',
                estado: ''
            };
        },
        async irDetalle(nrreporte, svindice, item) {
            let data = {
                nrreporte: item.Reporte + '-' + item.Indice,
                aiclave: item.aiclave,

            };

            let reporte = {
                nrreporte: item.Reporte,
                svindice: item.Indice,
                aiclave: item.aiclave,
                svfhconclusion: item.Fechaconclusión
            };


            let routerName = await MetodosGenerales.obtenerRouterName(parseInt(item.aiclave));
            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

            let url = this.$router.resolve({ name: `${routerName}`, params: { id: 0, } });
            window.open(url.href, '_blank');
        },

        async fetchData() {
            const response = this.listado;
            return response;
        },
        startDownload() {
            this.overlay = true;
            var formData = new FormData();
            formData.append("lasitio", 'Siniestros');
            formData.append("lomodulo", 'Estadisticas');
            formData.append("laaccion", "Descargar Archivo excel");
            formData.append("lacaracteristicas", "Estadisticas de reportes");
            formData.append("lanombre", this.nombreArchivo);
            formData.append("ladestinatario", "destinatario");
            Documentos.AlmacenarVisitas(this, formData).then(data => {
            });
        },
        finishDownload() {
        },
        limpiarBusqueda() {
            this.dialog = false;
            this.busqueda = {
                fechaini: '',
                fechafin: '',
                estado: ''
            };
        },
        async ObtenerEstados() {
            let response = await this.axios.post(`${this.domain.domainNameForApi}Busqueda/ObtenerEstado`);
            this.estados = response.data;
        },
        ObtenerDatos() {
            servicio.busquedaEstadistica(this, this.busqueda2).then(response => {
                this.dato = response;
                this.nuevaPeticion = true;
                this.dialog = false;
            });

        },
        busquedaEstadistica() {
            this.subtitulo = '';
            this.overlay = true;
            this.dialog = false;
            this.nuevoReporte = false;
            this.titulo = 'Estadistica';
            var ban = false;
            this.busqueda2 = this.busqueda;
            if (this.busqueda.fechaini != '' && this.busqueda.fechafin != '') {
                ban = true;
            }

            if (ban === true && this.busqueda.estado != '') {
                this.ObtenerDatos();
                this.subtitulo = 'Estado: ' + this.busqueda.estado.esnombre + " y Fecha: " + this.busqueda.fechaini + ' ' + this.busqueda.fechafin;
            }
            else if (ban === true && this.busqueda.estado == '') {
                this.ObtenerDatos()
                this.subtitulo += " Fecha: " + this.busqueda.fechaini + ' ' + this.busqueda.fechafin;
            }
            else if (ban === false && this.busqueda.estado != '') {
                this.ObtenerDatos();
                this.subtitulo = 'Estado: ' + this.busqueda.estado.esnombre;
            }
            else {

                this.$swal({
                    position: 'center',
                    icon: 'info',
                    title: 'Datos incompletos',
                    text: 'Debe de llenar el campo de fecha inicio y fin o seleccionar un estado',
                    showConfirmButton: false,
                    timer: 2500
                });
                this.dialog = true;
                this.$refs.multiselect.$el.focus();

                setTimeout(() => {
                    this.$refs.multiselect.$refs.search.blur();
                })
            }
            this.loadingTable = false;
        },
        async notify(tipo, total) {
            this.tipo = tipo;
            if (total > 0) {
                this.overlay = true;
                let data = {
                    Tipo: tipo,
                    FechaIni: this.busqueda2.fechaini,
                    FechaFin: this.busqueda2.fechafin,
                    Estado: this.busqueda2.estado.esclave
                };
                this.ObtenerReportes(data);
                this.nuevaPeticion = false;
                this.retorno = true;

                this.titulo = "Reportes";

                await Inicio.VerificarPermisos(this, "348").then(data => {
                    if (data.length > 0)
                        this.verificarpermisoexcel = true;
                });
            }

        },
        async ObtenerReportes(data) {
            this.tamaño = 100;
            this.headers = [];
            this.registro = 20;
            switch (data.Tipo) {
                case 1:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                        { text: 'Fecha Siniestro', value: 'FechaSiniestro', class: "text title" },
                        { text: 'Ajustador', value: 'Ajustador', class: "text title" },
                        { text: 'Asegurado', value: 'Asegurado', class: "text title" },
                        { text: 'Conductor', value: 'Conductor', class: "text title" },
                        { text: 'Poliza', value: 'Poliza', class: "text title" },
                        { text: 'Robo', value: 'Robo', class: "text title" },
                        { text: 'Delito', value: 'Delito', class: "text title" },
                        { text: 'Fecha Conclusión', value: 'Fechaconclusion', class: "text title" },
                        { text: 'Flotilla', value: 'Flotilla', class: "text title" },
                        { text: 'Fecha turnado', value: 'Fecha_turnado', class: "text title" },
                        { text: 'Fecha Contacto', value: 'Fecha_contacto', class: "text title" },
                        { text: 'Estado', value: 'Estado', class: "text title" },
                        { text: 'Av. previa', value: 'Avprevia', class: "text title" },
                        { text: 'Modelo', value: 'Modelo', class: "text title" },
                    ];
                    break;
                case 3:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Fecha Conclusión', value: 'Fechaconclusion', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Diferencia', value: 'Diferencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                    ];
                    break;
                case 4:
                    this.tamaño = 50;
                    this.registro = 50;
                    this.headers = [
                        { text: 'Forma de conclusión', value: 'Formadeconclusión', class: "text title" },
                        { text: 'Total', value: 'Total', class: "text title" },
                    ];
                    break;
                case 5:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                        { text: 'Estado', value: 'Estado', class: "text title" },
                        { text: 'Fecha Siniestro', value: 'Fecha_Siniestro', class: "text title" },
                        { text: 'Conductor', value: 'Conductor', class: "text title" },
                        { text: 'Asegurado', value: 'Asegurado', class: "text title" },
                        { text: 'Poliza', value: 'Poliza', class: "text title" },
                        { text: 'Delito', value: 'Delito', class: "text title" },
                        { text: 'Flotilla', value: 'Flotilla', class: "text title" },
                        { text: 'Modelo', value: 'Modelo', class: "text title" },
                        { text: 'Av. Previa', value: 'AvPrevia', class: "text title" },
                        { text: 'Reserva', value: 'Reserva', class: "text title" },
                    ];
                    break;
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                        { text: 'Reserva', value: 'Reserva', class: "text title" },
                    ];
                    break;
                case 11:
                case 12:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Estado', value: 'Estado', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                        { text: 'Fecha Siniestro', value: 'FechaSiniestro', class: "text title" },
                        { text: 'Días detenido', value: 'Díasdetenido', class: "text title" },
                        { text: 'Conductor', value: 'Conductor', class: "text title" },
                        { text: 'Asegurado', value: 'Asegurado', class: "text title" },
                        { text: 'Poliza', value: 'Poliza', class: "text title" },
                        { text: 'Peritaje', value: 'Peritaje', class: "text title" },
                        { text: 'Reserva', value: 'Reserva', class: "text title" },
                    ];
                    break;

                case 13:
                case 14:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                        { text: 'Estado', value: 'Estado', class: "text title" },
                        { text: 'Fecha Siniestro', value: 'FechaSiniestro', class: "text title" },
                        { text: 'Conductor', value: 'Conductor', class: "text title" },
                        { text: 'Asegurado', value: 'Asegurado', class: "text title" },
                        { text: 'Póliza', value: 'Poliza', class: "text title" },
                        { text: 'Delito', value: 'Delito', class: "text title" },
                        { text: 'Días sin peritaje', value: 'Diassinperitaje', class: "text title" },
                        { text: 'Peritaje', value: 'Peritaje', class: "text title" },
                        { text: 'Reserva', value: 'Reserva', class: "text title" },

                    ];
                    break;
                case 15:
                case 16:
                case 17:
                case 18:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                        { text: 'Reserva', value: 'Reserva', class: "text title" },
                    ];
                    break;
                case 2:
                case 19:
                    this.headers = [
                        { text: 'Reporte Ind', value: 'Reporte', class: "text title" },
                        { text: 'Fecha reporte', value: 'Fechareporte', class: "text title" },
                        { text: 'Fecha conclusión', value: 'Fechaconclusion', class: "text title" },
                        { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                        { text: 'Ciudad', value: 'Ciudad', class: "text title" },
                        { text: 'Aseguradora', value: 'Aseguradora', class: "text title" },
                        { text: 'Abogado', value: 'Abogado', class: "text title" },
                        { text: 'Num. Siniestro', value: 'NumSiniestro', class: "text title" },
                        { text: 'Forma de término', value: 'Formadetermino', class: "text title" },
                        { text: 'Estado', value: 'Estado', class: "text title" },
                        { text: 'Fecha Siniestro', value: 'FechaSiniestro', class: "text title" },
                        { text: 'Conductor', value: 'Conductor', class: "text title" },
                        { text: 'Asegurado', value: 'Asegurado', class: "text title" },
                        { text: 'Poliza', value: 'Poliza', class: "text title" },
                        { text: 'Peritaje', value: 'Peritaje', class: "text title" },
                        { text: 'Av. Previa', value: 'AvPrevia', class: "text title" },
                        { text: 'Delito', value: 'Delito', class: "text title" },
                        { text: 'Modelo', value: 'Modelo', class: "text title" },
                    ];
                    break;
            }
            this.loadingTable = true;
            await servicio.ListadoReportes(this, data).then(response => {
                let aux_listado = response;
                for (let i in aux_listado) {
                    for (const [key, value] of Object.entries(aux_listado[i])) {
                        if (typeof value === "object") {
                            aux_listado[i][key] = ""
                        }
                        else {
                            aux_listado[i][key] = value.toString()
                        }
                    }
                }

                this.listado = aux_listado;
                this.loadingTable = false;
            });

            setTimeout(() => {
                $("#tabla").DataTable({
                    lengthMenu: [
                        [20, 50, 100],
                        [20, 50, 100],
                    ],
                    pageLength: this.registro,
                    columnDefs: [{
                        className: 'dtr-control',
                        orderable: false,
                        targets: 0
                    }],
                    responsive: true,
                    "language": {
                        "sProcessing": "Procesando...",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sZeroRecords": "No se encontraron resultados",
                        "sEmptyTable": "Ningún dato disponible en esta tabla",
                        "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sSearch": "Buscar:",
                        "sUrl": "",
                        "sInfoThousands": ",",
                        "sLoadingRecords": "Cargando...",
                        "oPaginate": {
                            "sFirst": "Primero",
                            "sLast": "Último",
                            "sNext": "Siguiente",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
                            "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                        }
                    }
                });
            });
            this.nuevoReporte = true;
        },

        regresar() {
            this.nuevaPeticion = true;
            this.nuevoReporte = false;
            this.retorno = false;
            this.listado = [];
            this.headers = [];
            this.titulo = 'Estadistica';
            this.verificarpermisoexcel = false;
        },
    },
    mounted() {
        this.ObtenerEstados();
    },
    watch: {
        overlay(val) {
            val && setTimeout(() => {
                this.overlay = false
            }, 3000)
        },
    },
};
</script>
<style scoped>
.style2 {
    width: 236px;
}

.style3 {
    width: 345px;
}

.estlvl-1 {
    margin-left: 30px;
}

.estlvl-2 {
    margin-left: 60px;
}

.estlvl-3 {
    margin-left: 90px;
}

.hover:hover {
    color: #b9b7b7;
}
</style>
